export default "__VITE_ASSET__ecd8bfbe__"